const TENANT_PREFIX = {
  default: 'TRK',
  zaswin: 'DP',
};

export const getErrorCode = (errorType, tenant = 'default') => {
  const prefix = TENANT_PREFIX[tenant] || TENANT_PREFIX.default;

  const codes = {
    TENANT_LOAD_FAILED: `${prefix}-01`,
    INVALID_URL: `${prefix}-02`,
  };

  return codes[errorType] || `${prefix}-00`;
};

export const ERROR_TYPES = {
  TENANT_LOAD_FAILED: 'TENANT_LOAD_FAILED',
  INVALID_URL: 'INVALID_URL',
};
